import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);

// Optional: enable App Check (protects backend from abusive clients)
try {
  // Enable debug token in non-production if provided (useful for localhost)
  if (process.env.NODE_ENV !== 'production') {
    const debugToken = process.env.REACT_APP_APPCHECK_DEBUG_TOKEN;
    if (typeof window !== 'undefined' && debugToken) {
      // If set to 'true', Firebase will generate and log a debug token; or you can provide a fixed token
  // eslint-disable-next-line no-underscore-dangle
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken === 'true' ? true : debugToken;
    }
  }

  const siteKey = process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY;
  if (siteKey) {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(siteKey),
      isTokenAutoRefreshEnabled: true,
    });
  } else if (process.env.NODE_ENV === 'development') {
    console.warn('App Check not initialized: missing REACT_APP_RECAPTCHA_V3_SITE_KEY');
  }
} catch (e) {
  // Do not break app if App Check init fails
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.warn('App Check initialization error:', e);
  }
}
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
